import { z } from "zod";
import { localStore } from "../../../lib/store";

const NEW_ARTICLE_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export function isRecentArticle(creationDate: Date | string): boolean {
  const created = new Date(creationDate).getTime();
  return Date.now() - created < NEW_ARTICLE_WINDOW_MS;
}

const articleReadsStore = localStore<Record<string, number>>(
  "articleReads",
  {},
  z.record(z.string(), z.number())
);

export function recordArticleRead(articleId: string): void {
  articleReadsStore.set((prev) => {
    const cutoff = Date.now() - NEW_ARTICLE_WINDOW_MS;
    const pruned = Object.fromEntries(
      Object.entries(prev).filter(([, ts]) => ts > cutoff)
    );
    return { ...pruned, [articleId]: Date.now() };
  });
}

export function hasReadArticle(articleId: string): boolean {
  return articleReadsStore.get()[articleId] !== undefined;
}
